/* eslint-disable */
export default {
  logging: 'A registar...',
  logCall: 'Registar chamada',
  editLog: 'Editar registo',
  select: 'Sel. registo',
  OnHold: 'Em espera',
  Ringing: 'A chamar',
  CallConnected: 'Chamada ligada',
  unknownUser: 'Utilizador desconhecido',
  unknownNumber: 'Anónimo',
  unavailable: 'Indisponível',
  viewDetails: 'Ver detalhes',
  conferenceCall: 'Chamada de conferência',
  callerId: 'ID do autor da chamada',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"callerId"@#@ @source: @#@"Caller ID"@#@
